module.exports = __webpack_public_path__ + "img/9.b23da791.webp";